module.exports = __webpack_public_path__ + "img/banner3.0f1cdcf7.png";